<template>
    <div class="notice-info-wrap">
        <div class="info-wrap">
            <div class="top-logo">
                <img :src="loginT"/>
            </div>
            <div class="content-wrap" v-loading="loading">
                <div class="datail-title">{{content.title}}</div>
                <div class="time-bar" v-show="content.createTime">
                    <div class="time-info">
                        <span>发布日期：{{content.createTime}}</span>
                        <!-- <span>来源：{{content.author}}</span> -->
                    </div>
                </div>
                <div class="artucle-info" v-html="content.content"></div>
                <div v-if="content.noticeFileList && content.noticeFileList.length>0" class="file-box">
                    <div class="file-label">附件：</div>
                    <div class="file-list-box">
                        <div class="file-item" v-for="item in content.noticeFileList" :key='item.fileUrl'>
                            <div><el-link type="primary" :href="baseURL+item.fileUrl" target="_blank">{{item.fileName}}</el-link></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginT from '../../../assets/login_logo1.png'
import { noticeById } from '../../../api/notice'
export default {
    props: {

    },
    data() {
        return {
            loginT,
            content:{},
            noticeId:'',
        };
    },
    computed: {

    },
    created() {
        let route = this.$route;
        this.noticeId = route.params.id;  // 详情id
        this.getinfo()
        // let info = localStorage.getItem('editorTest');
        // if(info){
        //     this.content = JSON.parse(info)
        // }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        getinfo(){
            let _this = this;
            this.loading = true;
            noticeById({id:this.noticeId}).then(({data:res})=>{
                _this.loading = false;
                if(res.code == 0){
                    console.log(res)
                    _this.content = res.data;
                }
            })
        },
    },
    components: {

    },
};
</script>

<style lang="scss">
    .notice-info-wrap{
        width: 100%;
        min-height: 100vh;
        background: #F6F9FD;
        .info-wrap{
            width: 1240px;
            margin: 0 auto;
        }
        .top-logo{
            width: 100%;
            height: 40px;
            padding: 20px 0;
            text-align: left;
            background-color: #ff9811;
            img{
                height: 40px;
            }
        }
        .content-wrap{
            width: calc(100% - 140px);
            padding: 20px 70px;
            background: #fff;
            min-height: calc(100vh - 140px);
            .datail-title{
                width: 100%;
                line-height: 30px;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                color: #535353;
            }
            .time-bar{
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 10px;
                margin-bottom: 20px;
                div{
                    padding-top: 10px;
                    border-top:1px solid #e0e0e0 ;
                    font-size: 12px;
                    color: #535353;
                    span{
                        margin: 0 10px;
                    }
                }
            }
            .artucle-info{
                width: 100%;
                margin-bottom: 50px;
            }
        }
        .file-box{
            width: 100%;
            padding: 20px 0;
            .file-label{
                width: calc(100% - 20px);
                line-height: 20px;
                font-size: 14px;
                padding-left: 20px;
                position: relative;
                padding-bottom: 10px;
                border-bottom: 1px solid #efefef;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 5px;
                    height: 20px;
                    background: #ff9811;
                }
            }
            .file-list-box{
                width: 100%;
                max-height: 130px;
                overflow-y: auto;
                .file-item{
                    width: 100%;
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    margin: 10px 0;
                    div{
                        line-height: 32px;
                        height: 32px;
                        float: left;
                        /* border-bottom: 1px solid #efefef; */
                        display: flex;
                        .del{
                            margin-left: 20px;
                            font-size: 16px;
                            line-height: 32px;
                            color: red;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
